import React, { useEffect, useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Button,
  ModalCloseButton,
  useDisclosure,
  Skeleton,
} from '@chakra-ui/react'
import { useDispatch, useSelector } from 'react-redux'
import { userUpdate } from '../../../../commons/redux/actions/user.actions'
export default function Adress() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { user } = useSelector((state) => state.userReducer)
  const [adress, setAdress] = useState()
  const [town, setTown] = useState()
  const [load, setLoad] = useState(false)

  const [mess, setMess] = useState('')
  const [district, setdistrict] = useState()
  const dispatch = useDispatch()
  const update = async () => {
    setLoad(true)
    try {
      const res = await dispatch(userUpdate({ town, district }))
      if (res.statusText === 'Accepted') {
        setMess('Mise a jour reussie')
      }
      setLoad(false)
      console.log(res)
    } catch (error) {
      setLoad(false)
      console.log(error)
    }
  }
  useEffect(() => {
    if (typeof window !== 'undefined' && user && Object.keys(user).length > 0) {
      setAdress(user)
    }
  }, [user])

  return (
    <div>
      {!adress ? (
        <Skeleton height="150px" />
      ) : (
        <div className="bg-white adress rounded boder p-3 shaow-sm flex-col">
          <div className="flex justify-content-between flex-wrap">
            <h2 className=" font-bold text-2xl text-info">Adresse</h2>
            <button
              onClick={onOpen}
              className="font-bold text-muted text-xs bg-gray-100 px-3"
            >
              modifier
            </button>
          </div>
          <div className="flex-col">
            <h3 className="font-bold">Ville</h3>
            <p className="text-muted text-sm mb-1 ml-2">{adress?.town}</p>
          </div>
          <div className="flex-col">
            <h3 className="font-bold">Quartier</h3>
            <p className="text-muted text-sm mb-2 ml-2">{adress?.district}</p>
          </div>
        </div>
      )}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Modifier l'adress</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form class="w-full max-w-sm">
              {' '}
              <div className="text-center text-green-500 text-md ">
                <h6>{mess}</h6>
              </div>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Ville{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-full-name"
                    type="text"
                    name="town"
                    defaultValue={adress?.town}
                    onChange={(e) => setTown(e.target.value)}
                  />
                </div>
              </div>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Quartier{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-full-name"
                    type="text"
                    defaultValue={adress?.district}
                    onChange={(e) => setdistrict(e.target.value)}
                  />
                </div>
              </div>
              <div class="md:flex md:items-center">
                {load ? (
                  <div class="md:w-2/3">
                    <Button
                      isLoading
                      colorScheme={'blue'}
                      variant={'outline'}
                      loadingText={'En cours...'}
                      type="button"
                    ></Button>
                  </div>
                ) : (
                  <div class="md:w-2/3">
                    <button
                      onClick={update}
                      class=" btn bg-gray-300 hover:bg-green-400 focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded"
                      type="button"
                    >
                      modifier{' '}
                    </button>
                  </div>
                )}
              </div>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  )
}
